import CardContent from '@mui/material/CardContent';
import React, {useState, useEffect} from 'react';
import TextField from '@mui/material/TextField';
import {useTranslation} from "react-i18next";
import Button from '@mui/material/Button';
import {useNavigate} from 'react-router';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import {observer} from 'mobx-react';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import ObsAppBar from './AppBar.js';
import {COMM_OK} from './WsR2.js';

const Login = observer((props) => {
	const gStorage = useGlobalStorage();
	const navigate = useNavigate();
	let stored_user_id = '';

	let saved_user = window.localStorage.getItem('user');
	if (saved_user) {
		try {
			saved_user = JSON.parse(saved_user);
			if (saved_user.nick) {
				stored_user_id = saved_user.nick;
			}
		} catch {
		}
	}

	const [userId] = useState(React.createRef());
	const [pwd] = useState(React.createRef());

	const {t, i18n} = useTranslation('obs');

	const [user, setUser] = useState({nick: stored_user_id});
	const [login_err, setLoginErr] = useState(false);
	const [unErr, setUnErr] = useState(false);
	const [passwd, setPasswd] = useState('');

	useEffect(() => {
		let lang = window.localStorage.getItem('language');

		if (lang !== 'fi' && lang !== 'en')
			lang = 'en';

		i18n.changeLanguage(lang);

		if (!gStorage.conn.is_auth && user.nick)
			pwd.current.focus();

		// eslint-disable-next-line
	}, [gStorage.conn.is_auth, pwd, i18n]);

	function loginRxWs(status, msg) {
		if (status !== COMM_OK) {
			console.error('loginRxWs: comm error', status);
			return -1;
		}

		if (msg.cmd === 'login') {
			if (msg.result !== 'OK') {
// 				console.error('loginRxWs: login failed!', msg.data.desc);

				if (msg.data.desc.indexOf('username') > 0 && msg.data.desc.indexOf('not found') > 0) {
					setUnErr(true);
					setLoginErr(false);
					userId.current.focus();
				} else {
					setUnErr(false);
					setLoginErr(true);
					pwd.current.focus();
				}

				setPasswd('');
			}

			props.handleLogin(status, msg);
		} else {
			console.error('loginRxWs: unknown command', msg.cmd, msg.op);
		}
	}

	const signIn = (e) => {
// 		console.log('signIn begin');
		if (!gStorage.conn.connected) {
//			alert('No ws connection!');
			return;
		}

		if (user.nick === '') {
			userId.current.focus();
			return;
		}

		e.preventDefault();

		pwd.current.focus();

		let msg = {
			sess_id: '',
			cmd: 'login',
			op: '',
			data: {
				user: user.nick.toLowerCase(),
				passwd: passwd,
				tz: Intl.DateTimeFormat().resolvedOptions().timeZone
			}
		}

		gStorage.conn.ws.send(msg, loginRxWs);
	}

	const passwdChange = (event) => {
		setPasswd(event.target.value);
		if (login_err)
			setLoginErr(false);
// 		console.log('password', passwd);
	}

	const userChange = (event) => {
		setUser({nick: event.target.value});
		if (login_err)
			setLoginErr(false);
		if (unErr)
			setUnErr(false);
	}

	if (gStorage.conn.is_auth) {
		/* 
		 * Postpone navigation until drawing is done. 
		 * This could be avoided in way or another but right now 
		 * I'm too lazy to dig into this. 
		 */
		setTimeout(() => {
			navigate('/', { replace: true });
		}, 1);

		return null;
	}

	const getheader = () => {
		return t('login.login_op');
	}

	return (
		<div>
			<ObsAppBar {...props} getheader={getheader} />
			<Grid container direction="row" justifyContent="center" align='center'>
				<Grid size={{xs:12, sm: 6}}>
				<Card>
					<CardContent>
						<form name="login">
							<TextField
								label={t('login.id')}
								variant="outlined"
								size="small"
								autoFocus
								required
								fullWidth
								inputRef={userId}
								error={unErr}
								value={user.nick}
								onChange={userChange}
								style={{width:300, margin:8}}
								autoComplete='username'
							/>
							<div/>
							<TextField
								label={t('login.password')}
								variant="outlined"
								size="small"
								required
								fullWidth
								type="password"
								inputRef={pwd}
								error={login_err}
								value={passwd}
								onChange={passwdChange}
								style={{width:300, margin:8}}
								autoComplete='current-password'
							/>
							<div/>
							<Button 
								type="submit"
								variant="contained" 
								color="primary" 
								raised="true" 
								disabled={!gStorage.conn.connected || !passwd.length }
								onClick={signIn} 
								style={{marginTop:12}}>
								{t('login.login')}
							</Button>
						</form>
					</CardContent>
				</Card>
				</Grid>
			</Grid>
		</div>
	);
});

export default Login;
